import { Navigate, Outlet } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { useEffect, useState } from "react";

const AdminRoute = () => {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const session = await fetchAuthSession();

        const groups =
          session.tokens?.idToken?.payload?.["cognito:groups"] ||
          session.tokens?.accessToken?.payload?.["cognito:groups"] ||
          [];

        setAllowed(groups.includes("Admin"));
      } catch (err) {
        console.error("Admin check failed", err);
        setAllowed(false);
      } finally {
        setChecking(false);
      }
    };

    checkAdmin();
  }, []);

  if (checking) return <div style={{ padding: 20 }}>Checking access...</div>;

  return allowed ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default AdminRoute;
